var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.25013 21.0001C5.25013 20.5859 5.58592 20.2501 6.00013 20.2501H17.4287C17.8429 20.2501 18.1787 20.5859 18.1787 21.0001C18.1787 21.4143 17.8429 21.7501 17.4287 21.7501H6.00013C5.58592 21.7501 5.25013 21.4143 5.25013 21.0001Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.82162 8.71444C7.82162 8.30022 8.1574 7.96444 8.57162 7.96444H15.4288C15.843 7.96444 16.1788 8.30022 16.1788 8.71444C16.1788 9.12865 15.843 9.46444 15.4288 9.46444H8.57162C8.1574 9.46444 7.82162 9.12865 7.82162 8.71444Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 21.7501C11.5859 21.7501 11.2501 21.4143 11.2501 21.0001V14.0001C11.2501 13.5859 11.5859 13.2501 12.0001 13.2501C12.4143 13.2501 12.7501 13.5859 12.7501 14.0001V21.0001C12.7501 21.4143 12.4143 21.7501 12.0001 21.7501Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 15.7365L4.0151 4.32935C3.40203 3.45353 4.02859 2.25012 5.09766 2.25012H18.9026C19.9717 2.25012 20.5982 3.45353 19.9852 4.32935L12.0001 15.7365ZM12.0001 13.1208L18.5596 3.75012H5.44062L12.0001 13.1208Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWine);
export default __webpack_public_path__ + "static/media/wine.f1102bb49c4c9df4c2e8d2b99f7cd4e9.svg";
export { ForwardRef as ReactComponent };